import helperFunctions from "./helper-functions";
import buildingModel from "@/store/orm-axios/models/Building";
import buildingLotModel from "@/store/orm-axios/models/BuildingLot";
import buildingOwnerModel from "@/store/orm-axios/models/BuildingOwner";
import buildingOwnerBuildingLotModel from "@/store/orm-axios/models/BuildingOwnerBuildingLot";
import buildingOwnerVotingRightModel from "@/store/orm-axios/models/BuildingOwnerVotingRight";
import votingCategoryModel from "@/store/orm-axios/models/VotingCategory";
let eventSource;

const buildingIRI = "/buildings/";
const buildingLotIRI = "/building_lots/";
const buildingOwnerIRI = "/building_owners/";
const buildingOwnerBuildingLotIRI = "/building_owner_building_lots/";
const buildingOwnerVotingRightIRI = "/building_owner_voting_rights/";
const votingCategoryIRI = "/voting_categories/";
const importBuildingOwnerIRI = "/import_building_owners/";

export default {
  watch: {
    mercureJwtToken(oldValue, newValue) {
      if (oldValue.length != 0 && newValue.length != 0) {
        this.initBuildingsMercure();
      }
    },
  },
  created() {
    this.initBuildingsMercure();
  },
  destroyed() {
    eventSource.close();
  },
  methods: {
    async initBuildingsMercure() {
      if (!this.isAuthenticatedForMercure && this.isDesktop) {
        await helperFunctions.loginWebFromDesktop();
      }

      if (eventSource) eventSource.close();

      const topics = [
        `${buildingIRI}{id}`,
        `${buildingLotIRI}{id}`,
        `${buildingOwnerIRI}{id}`,
        `${buildingOwnerBuildingLotIRI}{id}`,
        `${buildingOwnerVotingRightIRI}{id}`,
        `${votingCategoryIRI}{id}`,
        `${importBuildingOwnerIRI}{id}`,
      ];

      eventSource = helperFunctions.getEventSource(topics);

      eventSource.onmessage = event => {
        const eventData = JSON.parse(event.data);

        var model = null;
        if (eventData["@id"].includes(buildingIRI)) {
          model = buildingModel;
        } else if (eventData["@id"].includes(buildingLotIRI)) {
          model = buildingLotModel;
        } else if (eventData["@id"].includes(buildingOwnerIRI)) {
          model = buildingOwnerModel;
        } else if (eventData["@id"].includes(buildingOwnerBuildingLotIRI)) {
          model = buildingOwnerBuildingLotModel;
        } else if (eventData["@id"].includes(buildingOwnerVotingRightIRI)) {
          model = buildingOwnerVotingRightModel;
        } else if (eventData["@id"].includes(votingCategoryIRI)) {
          model = votingCategoryModel;
        } else if (eventData["@id"].includes(importBuildingOwnerIRI)) {
          let progress = Number(eventData["import_progress"]);
          if (progress == 0) progress++;
          // Prevent to set NaN or undefined values
          if (eventData["token"] && progress) {
            this.$store.state.importBuildingOwners = {
              token: eventData["token"],
              import_progress: progress,
            };
          }
        }

        if (model) {
          helperFunctions.modifyInStore(eventData, model);
        }
      };

      helperFunctions.case401Error(eventSource);
    },
  },
};
